import React from 'react';
import PropTypes from 'react-proptypes';
import { FormValue } from '@fulcrumapp/fulcrum-core';
import ElementView from './base/element-view';

export default class LabelElementView extends ElementView {
  static propTypes = {
    ...ElementView.propTypes,
    value: PropTypes.instanceOf(FormValue),
  };
  // @ts-ignore
  renderContent() {
    // @ts-ignore
    const { styles } = LabelElementView;

    return (
      <div className={styles.label}>
        {/* @ts-ignore */}
        <h2 className={styles.header}>{this.props.element.label}</h2>
      </div>
    );
  }
}
// @ts-ignore
const styles = cssInJS({
  label: {
    width: '100%',
    fontWeight: 'bold',
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 10,
    paddingBottom: 10,
    lineHeight: '20px',

    '@phone': {
      display: 'block',
      width: '100%',
      fontWeight: 'bold',
      paddingTop: 6,
    },
  },

  header: {
    margin: 0,
    fontSize: 13,
    fontWeight: 'bold',
    padding: 0,
    width: 'auto',
    float: 'none',
    fontStyle: 'italic',
    whiteSpace: 'pre-wrap',
  },
});
// @ts-ignore
LabelElementView.styles = styles;
